const Constants = {
    Routes: {
        DEAD_END: '/dead-end',
        LOGIN: '/login',
        FORGOT_PASSWORD: '/reset-password',
        FORGOT_PASSWORD_CONFIRMATION: '/reset-password-confirmation',
        CREATE_ACCOUNT: '/create-account',
        CREATE_ACCOUNT_CONFIRMATION: '/create-account-confirmation',
        LINK_ACCOUNT: '/link-account',
        REDIRECT_URI: '/redirect-uri'
    },
    Resources: {
        Common: {
            FORGOT_PASSWORD: 'forgotPassword',
            CREATE_NEW_ACCOUNT: 'createNewAccount',
            LOGO_TEXT: 'logoText',
            BACK_TO_SIGN_IN: 'backToSignIn'
        },
        Authentication: {
            DEAD_END_MESSAGE: 'deadEndMessage'
        },
        Login: {
            LOGIN_FORM_HEADER: 'loginFormHeader',
            SIGN_IN_BUTTON: 'signInButton',
            INVALID_PASSWORD: 'invalidPassword'
        },
        ForgotPassword: {
            ENTER_USERNAME_EMAIL: 'enterUsernameEmail',
            RECOVER_PASSWORD: 'recoverPassword'
        },
        ForgotPasswordConfirmation: {
            FORGOT_PASSWORD_CONFIRMATION: 'forgotPasswordConfirmation',
            DID_NOT_RECEIVE_EMAIL: 'didNotReceiveEmail',
            CHECK_SPAM: 'checkSpam',
            RESEND_VERIFICATION: 'resendVerification'
        },
        LinkAccount: {
            PERMISSIONS_REQUESTED: 'permissionsRequested',
            ATTENTION_USER: 'attentionUser',
            REQUIRED_PERMISSIONS: 'requiredPermissions',
            CANCEL_BUTTON: 'cancelButton',
            ACCEPT_BUTTON: 'acceptButton'
        }
    }
};

export default Constants;
